import {
    ReloadButton,
    SimplePageHeader,
} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useMessages} from '../hooks/useMessages';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton.tsx';
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {TagMultipleButton} from '../buttons/TagMultipleButton.tsx';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {useIndexPageHeader} from '../hooks/useIndexPageHeader';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {GenerateMessageButton} from '../../test-data/buttons/GenerateMessageButton.tsx';

const ComponentsReloadButton = () => {

    const {refetchRecords} = useMessages();
    return (
        <Box mx='s'>
            <ReloadButton onClick={refetchRecords}/>
        </Box>
    );
};


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [
        <ComponentsReloadButton key='reload'/>
    ];

    if (allowedActions.includes(rbacActions.UpdateMessage)) {
        tools.push(<TagMultipleButton key='tag-multiple'/>);
    }

    if (allowedActions.includes(rbacActions.DeleteMessage)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateMessage)) {
        tools.push(<AddRecordButton key='add'/>);
        // FNP-1521: generation WRITES messages, so it sits behind the same
        // permission as creating one. The button renders itself as null outside
        // dev/test — the stage gate lives in the component so every mount site
        // inherits it rather than each one remembering to ask.
        tools.push(<GenerateMessageButton key='generate'/>);
    }


    return tools;
};

export const IndexPageHeader = () => {
    const { title } = useIndexPageHeader();

    return (
        <SimplePageHeader
            title={title}
            tools={useTools()}
        />
    );
};